module.exports = __webpack_public_path__ + "img/tablePlate.e2a98ba8.jpg";